 (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      if (!upsells) return
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        const upsellEl = document.querySelector('#cart-drawer-upsell')
        if (upsellEl) upsellEl.remove()
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          try {
            const respoonse = await fetch(window.location.href)
            const text = await respoonse.text()
            const newDocument = new DOMParser().parseFromString(text, 'text/html')

            const currentWrapper = document.querySelector('#cart-drawer-upsell-wrapper')
            const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper')
            if (currentWrapper && newWrapper) {
              currentWrapper.replaceWith(newWrapper)
            }

            insertSectionCartDrawer()
          } catch(e) {
            console.warn('[cart-upsell] drawer refresh error:', e)
          }
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => {
        // Only react to structural DOM changes, not attribute changes (e.g. loading spinner class toggles)
        // Attribute changes fire mid-delete and cause stale page fetches that corrupt the upsell section
        const hasStructureChange = mutations.some(function(m) { return m.type === 'childList' })
        if (!hasStructureChange) return

        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          try {
            const respoonse = await fetch(window.location.href)
            const text = await respoonse.text()
            const newDocument = new DOMParser().parseFromString(text, 'text/html')

            const currentWrapper = document.querySelector('#cart-drawer-upsell-wrapper')
            const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper')
            if (currentWrapper && newWrapper) {
              currentWrapper.replaceWith(newWrapper)
            }
            // insertSectionCartPage() was removed — function is commented out above
          } catch(e) {
            console.warn('[cart-upsell] page refresh error:', e)
          }
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();